<template>
    <div class="col-lg-12 mx-2">
        <ContentContainer>
            <template v-slot:content>
                <!-- Dashboard Heading -->
                <div class="dashboard-heading mb-4">
                    <div class="dh-icon-wrap dh-icon-join">
                        <i class="material-icons">group_add</i>
                    </div>
                    <div>
                        <h5 class="dh-title">Join Organization</h5>
                        <p class="dh-subtitle">Search and request to join an existing organization</p>
                    </div>
                </div>

                <div>
                    <div v-if="stLocationsAll.length > 0" class="container" style="height: 63vh; overflow-y: auto;">
                        <p class="font-weight-bold">Please find below your current Organization(s):</p>

                        <div class="gap-3">
                            <div v-for="org in stLocationsAll" :key="org.organization_id"
                                class="d-flex flex-row flex-wrap gap-4 mb-5">
                                <div v-for="location in org.locations" :key="location.location_id" class="card p-4 my-2"
                                    :class="getLocationStatusClass(location.location_status)"
                                    :style="getLocationStatusStyle(location.location_status)">
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="48px"
                                                viewBox="0 -960 960 960" width="48px" fill="white">
                                                <path
                                                    d="M480.09-490q28.91 0 49.41-20.59 20.5-20.59 20.5-49.5t-20.59-49.41q-20.59-20.5-49.5-20.5t-49.41 20.59q-20.5 20.59-20.5 49.5t20.59 49.41q20.59 20.5 49.5 20.5ZM480-159q133-121 196.5-219.5T740-552q0-117.79-75.29-192.9Q589.42-820 480-820t-184.71 75.1Q220-669.79 220-552q0 75 65 173.5T480-159Zm0 79Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <div class="mb-2 text-white">
                                                <div><span class="font-weight-bold my-1 text-white">Organization:
                                                    </span>{{
                                                        org.organization_name }} </div>
                                                <div> <span class="font-weight-bold my-1 text-white">Location: </span>{{
                                                    location.location_name }} </div>
                                                <div> <span class="font-weight-bold my-1 text-white">Membership Status: </span>{{
                                                    getLocationStatusLabel(location.location_status) }} </div>
                                                <div v-if="location.location_status === 0" class="mt-2" style="font-size: 0.85rem; opacity: 0.9;">
                                                    <i class="material-icons" style="font-size: 16px; vertical-align: middle;">info</i>
                                                    Your request to join is currently pending admin review and approval.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-center">You are currently not a part of an Organization.
                            Use the Search below to search and then request to join an existing Organization</p>
                    </div>
                    <hr class="my-2" />
                    <div v-if="!showJoinReason" class="w-50 mx-auto text-center" style="margin-top: 40px;">
                        <div>
                            <p class="font-weight-bold m-0">
                                Enter a part of your organization's name in the search box below for best results:
                            </p>
                        </div>
                        <form @submit.prevent="handleSearch">
                            <div class="my-2 w-full d-flex">
                                <material-input id="searchbox" type="text" v-model="searchString"
                                    placeholder="Search organization" name="searchbox" />
                                <material-button class="mx-2 py-0 w-50" size="xxl" variant="gradient" color="success"
                                    :disabled="searchStatus === 'loading'">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960"
                                        width="30px" fill="#EFEFEF">
                                        <path
                                            d="M796-121 533-384q-30 26-69.96 40.5Q423.08-329 378-329q-108.16 0-183.08-75Q120-479 120-585t75-181q75-75 181.5-75t181 75Q632-691 632-584.85 632-542 618-502q-14 40-42 75l264 262-44 44ZM377-389q81.25 0 138.13-57.5Q572-504 572-585t-56.87-138.5Q458.25-781 377-781q-82.08 0-139.54 57.5Q180-666 180-585t57.46 138.5Q294.92-389 377-389Z" />
                                    </svg>
                                    Search</material-button>
                            </div>
                        </form>
                    </div>
                    <!-- <div v-if="!showJoinReason" class="d-flex" style="margin-top: 40px;">

                    <div v-for="org in organizations" :key="org.locationid" class="w-50">
                        <div class="card p-4">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960"
                                    width="48px" fill="#75FB4C">
                                    <path
                                        d="M480.09-490q28.91 0 49.41-20.59 20.5-20.59 20.5-49.5t-20.59-49.41q-20.59-20.5-49.5-20.5t-49.41 20.59q-20.5 20.59-20.5 49.5t20.59 49.41q20.59 20.5 49.5 20.5ZM480-159q133-121 196.5-219.5T740-552q0-117.79-75.29-192.9Q589.42-820 480-820t-184.71 75.1Q220-669.79 220-552q0 75 65 173.5T480-159Zm0 79Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                                </svg>
                            </div>
                            <div>
                                <div class="mb-2">
                                    <div class="font-weight-bold"> {{ org.orglocationname }} </div>
                                    <div> <span class="font-weight-bold my-1">Location: </span>{{ org.locationname
                                        }}
                                    </div>
                                    <div> <span class="font-weight-bold my-1">Time Zone: </span>{{ org.timezone }}
                                    </div>
                                </div>
                            </div>
                            <hr class="my-2" />
                            <div class="d-flex justify-content-end mt-2">
                                <div role="button" class="underline-hover text-success link-underline-success"
                                    @click="showReason(org)"> JOIN ORGANIZATION </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                    <div v-if="!showJoinReason" style="margin-top: 40px;">
                        <div v-if="organizations && (Array.isArray(organizations) ? organizations.length > 0 : Object.keys(organizations).length > 0)" class="row g-3">
                            <div v-for="org in organizations" :key="org.locationid" class="col-12 col-md-6 col-lg-4">
                                <div class="organization-card card h-100 shadow-sm border-0">
                                    <div class="card-body p-4 d-flex flex-column">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="location-icon-wrapper me-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960"
                                                    width="40px" fill="#75FB4C">
                                                    <path
                                                        d="M480.09-490q28.91 0 49.41-20.59 20.5-20.59 20.5-49.5t-20.59-49.41q-20.59-20.5-49.5-20.5t-49.41 20.59q-20.5 20.59-20.5 49.5t20.59 49.41q20.59 20.5 49.5 20.5ZM480-159q133-121 196.5-219.5T740-552q0-117.79-75.29-192.9Q589.42-820 480-820t-184.71 75.1Q220-669.79 220-552q0 75 65 173.5T480-159Zm0 79Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                                                </svg>
                                            </div>
                                            <div class="flex-grow-1">
                                                <h6 class="m-0 fw-bold organization-name">
                                                    {{ org.orglocationname }}
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="organization-details mb-3">
                                            <div class="mb-2">
                                                <span class="small fw-semibold text-muted">Location:</span>
                                                <span class="ms-1">{{ org.locationname }}</span>
                                            </div>
                                            <div class="mb-2">
                                                <span class="small fw-semibold text-muted">Time Zone:</span>
                                                <span class="ms-1">{{ org.timezone }}</span>
                                            </div>
                                            <div>
                                                <span class="small fw-semibold text-muted">Membership Status:</span>
                                                <span class="ms-1 fw-bold">{{ getMembershipStatusLabel(org.member_status) }}</span>
                                            </div>
                                        </div>
                                        <div class="mt-auto pt-3 border-top">
                                            <button type="button" 
                                                class="btn btn-sm w-100 join-btn"
                                                :class="getButtonClass(org.member_status)"
                                                @click="showReason(org)"
                                                :disabled="isMembershipActive(org.member_status)">
                                                <i class="material-icons me-1" style="font-size: 18px; vertical-align: middle;">add_circle</i>
                                                {{ getButtonText(org.member_status) }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="searchStatus === 'loading'" class="alert alert-info text-center mt-3" role="status" aria-live="polite">
                            Searching for organizations matching “{{ lastSearchedTerm }}”...
                        </div>
                        <div v-else-if="searchStatus === 'success' && organizations.length === 0"
                            class="alert alert-info text-center mt-3" role="status" aria-live="polite">
                            <strong>No organizations matched “{{ lastSearchedTerm }}”.</strong>
                            Try a different keyword from your organization's name.
                        </div>
                        <div v-else-if="searchStatus === 'error'" class="alert alert-warning text-center mt-3" role="alert">
                            The organization search couldn't be completed. Please try again.
                        </div>
                    </div>


                    <div v-else class="w-50 mx-auto">
                        <p>You have selected following location: </p>
                        <h6>{{ selectedLocation.orglocationname }}</h6>
                        <form @submit.prevent="handleOrganization">
                            <MaterialTextarea id="reason-box" name="reasonBox" class="p-2" v-model="joinReason" :isRequired="true"
                                :disabled="false" variant="filled" placeholder="Enter reason to join this organization">
                            </MaterialTextarea>
                            <div class="d-flex gap-3 my-2">
                                <material-button type="submit" class="mb-2 py-2 w-50" size="sm" variant="gradient"
                                    color="success" fullWidth>Join
                                </material-button>
                                <material-button type="button" class="mb-2 py-2 w-50" size="sm" variant="gradient"
                                    color="danger" @click="back" fullWidth>Back</material-button>
                            </div>
                        </form>
                    </div>
                </div>
            </template>
        </ContentContainer>
    </div>
</template>

<script>
import ContentContainer from '@/components/PageLayout/ContentContainer.vue';
import MaterialInput from "@/components/common/MaterialInput.vue";
import MaterialButton from "@/components/common/MaterialButton.vue";
import MaterialTextarea from "@/components/common/MaterialTextarea.vue";
import { mapGetters, mapActions } from 'vuex';
import LoggerService from "@/services/LoggerService";

export default {
    name: "join-organization",
    data() {
        return {
            searchString: "",
            organizations: [],
            searchStatus: 'idle',
            lastSearchedTerm: '',
            searchRequestId: 0,
            selectedLocation: {},
            joinReason: '',
            showJoinReason: false
        };
    },
    components: {
        ContentContainer,
        MaterialInput,
        MaterialButton,
        MaterialTextarea
    },
    computed: {
        ...mapGetters([
            'stSessionData',
            'stJoinOrganizationResponse',
            'stLocationsAll'
        ]),
    },
    methods: {
        ...mapActions([
            'fetchSearchData',
            'joinOrganization',
            'fetchPersonLocations'
        ]),

        showReason(org) {
            this.selectedLocation = org
            this.showJoinReason = true
        },

        back() {
            this.showJoinReason = false
            this.joinReason = ""
            this.selectedLocation = {}
        },

        async handleSearch() {
            if (!this.searchString || !this.searchString.trim()) {
                this.$toast.warning('Please enter a search term before searching', {
                    position: 'top-right',
                    duration: 3000
                });
                return;
            }
            if (this.searchStatus === 'loading') return;

            const searchTerm = this.searchString.trim();
            const requestId = ++this.searchRequestId;
            this.lastSearchedTerm = searchTerm;
            this.searchStatus = 'loading';
            this.organizations = [];

            try {
                const response = await this.fetchSearchData(searchTerm);
                if (requestId !== this.searchRequestId) return;
                this.organizations = Array.isArray(response)
                    ? response
                    : (response && typeof response === 'object' ? Object.values(response) : []);
                this.searchStatus = 'success';

                // Count the number of results
                const count = this.organizations.length;

                // Show toast with result count
                if (count > 0) {
                    this.$toast.info(`${count} organization->locations returned from your search. Scroll down to see results.`, {
                        position: 'top-right',
                        duration: 5000
                    });
                }
            } catch (error) {
                if (requestId !== this.searchRequestId) return;
                this.searchStatus = 'error';
                console.error('Error searching organizations:', error);
                this.$toast.error('Failed to search organizations', {
                    position: 'top-right',
                    duration: 3000
                });
            }
        },

        async handleOrganization() {

            let payload = {
                personid: this.stSessionData.personId,
                locationid: this.selectedLocation.locationid,
                joinreason: this.joinReason
            }

            await this.joinOrganization(payload).then(() => {
                // Log user request to join organization
                LoggerService.logDataOperation(
                    'JOIN_REQUEST',
                    'organization',
                    this.selectedLocation.locationid,
                    {
                        organizationName: this.selectedLocation.orglocationname,
                        locationName: this.selectedLocation.locationname,
                        reason: this.joinReason
                    },
                    this.stSessionData?.personId
                );
                
                this.$toast.success(this.stJoinOrganizationResponse.message, {
                    position: 'top-right',
                });
                this.showJoinReason = false
                this.joinReason = ""
                // Refresh person locations to update the current organizations list
                if (this.stSessionData && this.stSessionData.personId) {
                    this.fetchPersonLocations({
                        personid: this.stSessionData.personId,
                        allrecords: true
                    })
                }
            })
        },

        // Get location status label (for current organizations - uses location_status: 1=active, 0=inactive)
        getLocationStatusLabel(locationStatus) {
            if (locationStatus === 1) return 'Active';
            if (locationStatus === 0) return 'Pending Review';
            // Fallback for backward compatibility
            return 'Active';
        },

        // Get location status background style (for current organizations cards)
        getLocationStatusStyle(locationStatus) {
            if (locationStatus === 1) {
                return { backgroundColor: '#226E25' }; // Green for active
            }
            if (locationStatus === 0) {
                return { backgroundColor: '#0d6efd' }; // Blue for pending review
            }
            return { backgroundColor: '#226E25' }; // Default to green
        },

        // Get location status class (for current organizations cards)
        getLocationStatusClass(locationStatus) {
            if (locationStatus === 1) return 'location-active';
            if (locationStatus === 0) return 'location-inactive';
            return 'location-active'; // Default
        },

        // Get membership status label (for search results - uses locationperson_status: 1=active, 0=inactive)
        getMembershipStatusLabel(status) {
            if (status === 1) return 'Active';
            if (status === 0) return 'Inactive';
            // Fallback for backward compatibility with string values
            if (!status) return 'Not a member';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'Active';
            if (statusLower === 'pending' || statusLower === 'requested') return 'Pending';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'Declined';
            return 'Not a member';
        },

        // Get background color class based on membership status (1=active, 0=inactive)
        getMembershipStatusClass(status) {
            if (status === 1) return 'membership-active';
            if (status === 0) return '';
            // Fallback for backward compatibility with string values
            if (!status) return '';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'membership-active';
            if (statusLower === 'pending' || statusLower === 'requested') return 'membership-pending';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'membership-declined';
            return '';
        },

        // Get text color class based on membership status (1=active, 0=inactive)
        getTextColorClass(status) {
            if (status === 1) return 'text-white';
            if (status === 0) return 'text-dark';
            // Fallback for backward compatibility with string values
            if (!status) return 'text-dark';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'text-white';
            if (statusLower === 'pending' || statusLower === 'requested') return 'text-white';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'text-white';
            return 'text-dark';
        },

        // Get label color class based on membership status (1=active, 0=inactive)
        getLabelColorClass(status) {
            if (status === 1) return 'text-white-50';
            if (status === 0) return 'text-muted';
            // Fallback for backward compatibility with string values
            if (!status) return 'text-muted';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'text-white-50';
            if (statusLower === 'pending' || statusLower === 'requested') return 'text-white-50';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'text-white-50';
            return 'text-muted';
        },

        // Get border color class based on membership status (1=active, 0=inactive)
        getBorderColorClass(status) {
            if (status === 1) return 'border-white-50';
            if (status === 0) return '';
            // Fallback for backward compatibility with string values
            if (!status) return '';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'border-white-50';
            if (statusLower === 'pending' || statusLower === 'requested') return 'border-white-50';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'border-white-50';
            return '';
        },

        // Get button class based on membership status (1=active, 0=inactive)
        getButtonClass(status) {
            if (status === 1) return 'btn-light';
            if (status === 0) return 'btn-success';
            // Fallback for backward compatibility with string values
            if (!status) return 'btn-success';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'btn-light';
            if (statusLower === 'pending' || statusLower === 'requested') return 'btn-warning';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'btn-danger';
            return 'btn-success';
        },

        // Get button text based on membership status (1=active, 0=inactive)
        getButtonText(status) {
            if (status === 1) return 'Already a Member';
            if (status === 0) return 'Join Organization';
            // Fallback for backward compatibility with string values
            if (!status) return 'Join Organization';
            const statusLower = String(status).toLowerCase();
            if (statusLower === 'active' || statusLower === 'approved') return 'Already a Member';
            if (statusLower === 'pending' || statusLower === 'requested') return 'Request Pending';
            if (statusLower === 'declined' || statusLower === 'rejected') return 'Request Declined';
            return 'Join Organization';
        },

        // Check if membership status is active (disabled button condition)
        isMembershipActive(status) {
            if (status === 1) return true;
            if (!status) return false;
            const statusLower = String(status).toLowerCase();
            return statusLower === 'active' || statusLower === 'approved';
        },
    },
    mounted() {
        // Refresh person locations with allrecords parameter
        if (this.stSessionData && this.stSessionData.personId) {
            this.fetchPersonLocations({
                personid: this.stSessionData.personId,
                allrecords: true
            })
        }
    }
};
</script>

<style scoped>
/* Dashboard heading */
.dashboard-heading {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.25rem;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.dh-icon-wrap {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #fff;
}
.dh-icon-wrap i { font-size: 28px; }
.dh-icon-join { background: linear-gradient(135deg, #ffa726, #ef6c00); }
.dh-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: #344767;
}
.dh-subtitle {
    margin: 0;
    font-size: 0.78rem;
    color: #7b809a;
    margin-top: 2px;
}

.organization-card {
    transition: all 0.3s ease;
    border-radius: 12px;
    overflow: hidden;
    background-color: #ffffff;
}

.organization-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

/* Membership Status Background Colors */
.organization-card.membership-active {
    background-color: #226E25 !important;
    background: linear-gradient(135deg, #226E25 0%, #2d8a31 100%);
}

.organization-card.membership-pending {
    background-color: #0d6efd !important;
    background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
}

.organization-card.membership-declined {
    background-color: #dc3545 !important;
    background: linear-gradient(135deg, #dc3545 0%, #bb2d3b 100%);
}

/* Text color utilities for status backgrounds */
.membership-active .text-white-50,
.membership-pending .text-white-50,
.membership-declined .text-white-50 {
    color: rgba(255, 255, 255, 0.8) !important;
}

.membership-active .border-white-50,
.membership-pending .border-white-50,
.membership-declined .border-white-50 {
    border-color: rgba(255, 255, 255, 0.3) !important;
}

.location-icon-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: rgba(117, 251, 76, 0.1);
    border-radius: 10px;
    padding: 4px;
}

.membership-active .location-icon-wrapper {
    background-color: rgba(255, 255, 255, 0.2);
}

.membership-active .location-icon-wrapper svg {
    fill: #ffffff;
}

.membership-pending .location-icon-wrapper {
    background-color: rgba(255, 255, 255, 0.2);
}

.membership-pending .location-icon-wrapper svg {
    fill: #ffffff;
}

.membership-declined .location-icon-wrapper {
    background-color: rgba(255, 255, 255, 0.2);
}

.membership-declined .location-icon-wrapper svg {
    fill: #ffffff;
}

.organization-name {
    font-size: 1.1rem;
    line-height: 1.4;
    color: #2c3e50;
}

.organization-details {
    font-size: 0.9rem;
    line-height: 1.6;
}

.join-btn {
    font-weight: 600;
    letter-spacing: 0.5px;
    border-radius: 8px;
    padding: 10px 16px;
    transition: all 0.2s ease;
}

.join-btn:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.join-btn:active {
    transform: scale(0.98);
}

.underline-hover:hover {
    text-decoration: underline green;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .organization-card {
        margin-bottom: 1rem;
    }
}
</style>